<micro-lookup domain="sms" obj="smsMoToEmails" url="/sms/smsMoToEmails" [key]="smsMoToEmailId" [link]="link"></micro-lookup>
